// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t2JCv4vEeJvSdR {
  display: flex;
  padding: var(--ds-space-100, 8px);
}
.t2JCv4vEeJvSdR span {
  min-width: 20px;
  margin-right: var(--ds-space-050, 4px);
}
.t2JCv4vEeJvSdR p {
  margin: var(--ds-space-0, 0);
}
.fERULXENMU1YgY {
  font-size: 11px;
  line-height: 14px;
}
.Oh8JPXbKw0xBGv {
  font-size: 12px;
}
.sEAs3JkodZIAgj {
  margin-top: var(--ds-space-100, 8px);
}
`, ""]);
// Exports
export var mirrorCardAccessRestricted = `t2JCv4vEeJvSdR`;
export var content = `fERULXENMU1YgY`;
export var message = `Oh8JPXbKw0xBGv`;
export var requestAccessButton = `sEAs3JkodZIAgj`;
export default ___CSS_LOADER_EXPORT___;
